import Letter from './Letter';
import Introduction from './Introduction';
import Chapter1 from './Chapter1';
import Chapter2 from './Chapter2';
import Chapter3 from './Chapter3';
import Chapter4 from './Chapter4';
import Chapter5 from './Chapter5';
import Chapter6 from './Chapter6';
import Chapter7 from './Chapter7';
import Chapter8 from './Chapter8';
import Chapter9 from './Chapter9';
import Chapter10 from './Chapter10';
import Chapter11 from './Chapter11';
import Carousel from '../Carousel';

export const Pages = [
	{ path: '/letter-from-the-president', name: 'A Letter from <br />the President', color: 'default', Component: Letter },
	{ path: '/the-first-100-years', name: 'Peapack-Gladstone <br />Bank: The First <br />100 Years', color: 'default', Component: Introduction },
	{ path: '/peapack-gladstone-national-bank', name: 'Peapack-Gladstone <br />National Bank', color: 'default', Component: Chapter1 },
	{ path: '/forming-a-true-community-bank', name: 'Forming a True <br />Community Bank', color: 'default', Component: Chapter2 },
	{ path: '/peapack-gladstone-trust-company', name: 'Peapack-Gladstone <br />Trust Company', color: 'default', Component: Chapter3 },
	{ path: '/persevering-through-hard-times', name: 'Persevering Through <br />Hard Times', color: 'default', Component: Chapter4 },
	{ path: '/stability-and-prosperity', name: 'Stability and <br />Prosperity', color: 'default', Component: Chapter5 },
	{ path: '/progress-technology-and-a-trust-department', name: 'Progress, Technology, <br />and a Trust Department', color: 'green', Component: Chapter6 },
	{ path: '/lifestyle-becomes-a-mural-becomes-a-logo', name: 'Lifestyle Becomes a <br />Mural Becomes a Logo', color: 'green', Component: Chapter7 },
	{ path: '/leader-for-all-generations', name: 'Leader for All <br />Generations: <br />T. Leonard Hill', color: 'green', Component: Chapter8 },
	{ path: '/the-tiffany-of-new-jersey-banking', name: '"The Tiffany of New <br />Jersey Banking"', color: 'green', Component: Chapter9 },
	{ path: '/expanding-our-reach', name: 'Expanding <br />Our Reach', color: 'green', Component: Chapter10 },
	{ path: '/invested-in-our-community', name: 'Invested in Our <br />Community', color: 'green', Component: Chapter11 }
];

export const NonPages = [
	{ path: '/', name: 'Peapack-Gladstone 100 Anniversary', color: 'default', Component: Carousel }
];

export const AllPages = NonPages.concat(Pages);

export const Settings = {
	imageSelectors: '.entry-content figure:not(.no-anim), .entry-content figcaption:not(.no-anim), .entry-content .caption:not(.no-anim)'
};